import React, { useEffect, useState } from "react";
import { Button, FormControl, MenuItem, Select, TextField } from "@mui/material";
import BreadCrumb from "../../../../Admin-Dashboard/@components/Breadcrumb";
import Sidebar from "../../../components/Sidebar";
import {
  createCommunicationTableData,
  getParticularCommunicationTableData,
  updateParticularCommunicationTableData,
} from "../../../../Admin-Dashboard/apiHandler/preference.service";
import { setMessage } from "../../../../store/slices/Notification";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CkEditorFullOptions from "../view/Ckeditor";

interface FormState {
  movie: string;
  msgType: string;
  name: string;
  header: string;
  headerImage: string;
  footer: string;
  optionKey: string;
  optionKeyMappingText: string;
  gupshupTemplateId: string;
  qrPayload: string;
  buttonUrlParam: string;
  isActive: string;
  isPushed: string;
  categoryType: string
}

// Utility function to convert label to camelCase
const toCamelCase = (str: string): string =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match: string, index: number) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, "");

const CrateEditFlowForCommunication: React.FC = () => {
  const [formState, setFormState] = useState<any>({
    name: "",
    isActive: "false",
    body: "",
    subject: "",
    isPushed: false,
    categoryType: null
  });

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      getParticularCommunicationTableData(id).then((res) => {
        setFormState({ ...res?.data, isActive: res?.data?.isActive ? "true" : "false" });
      });
    }
  }, [id]);

  const navigate = useNavigate();

  const handleChange = (key: keyof FormState) => (event: React.ChangeEvent<HTMLInputElement | { value: string }>) => {
    setFormState((prev: any) => ({ ...prev, [key]: event.target.value }));
  };
  const dispatch = useDispatch();

  const onSave = async () => {
    try {
      if (!formState.name) {
        dispatch(setMessage({ type: "error", message: "Name is required" }));
        return;
      }
      if (!formState.body) {
        dispatch(setMessage({ type: "error", message: "Body is required" }));
        return;
      }
      if (!formState.messageType) {
        dispatch(setMessage({ type: "error", message: "Message Type is required" }));
        return;
      }
      if (!formState.communicationType) {
        dispatch(setMessage({ type: "error", message: "Communication Type is required" }));
        return;
      }
      if (!formState.templateLang) {
        dispatch(setMessage({ type: "error", message: "Template Language is required" }));
        return;
      }
      if (!formState.providerType) {
        dispatch(setMessage({ type: "error", message: "Provider Type is required" }));
        return;
      }
      if (id) {
        await updateParticularCommunicationTableData(id, {
          ...formState,
          isActive: formState?.isActive === "false" ? false : true,
        })
          .then((res: any) => {
            dispatch(setMessage({ type: "success", message: "Template updated successfully" }));
            // window.location.reload();
          })
          .catch((err) => {
            throw err;
          });
      } else {
        await createCommunicationTableData({
          ...formState,
          isActive: formState?.isActive === "false" ? false : true,
        })
          .then((res: any) => {
            console.log(">>>>>>>res", res);
            dispatch(setMessage({ type: "success", message: "Template created successfully" }));
            navigate("/dashboard/user-notification/communication-template");
          })
          .catch((err) => {
            throw err;
          });
      }
    } catch (err: any) {
      console.log(">>>>>>>err", err);
      dispatch(setMessage({ type: "error", message: err?.response?.data?.message || "Something went wrong" }));
    }
  };

  return (
    <>
      <div className="flex">
        <Sidebar active_link="/dashboard/whatsapp-template" type="data_collection" title="Dashboard" />
        <div className="pl-8 w-[75%]  dashboard-image mt-20">
          <div className="header-container ">
            <div className="w-full">
              <BreadCrumb
                breadCrumbArray={[
                  {
                    label: "Dashboard",
                    link: "/dashboard",
                  },
                  { label: "Communication Template", link: "/dashboard/user-notification/communication-template" },
                  { label: id ? "Edit" : "Create", link: "" },
                ]}
              />{" "}
              <div className="flex justify-between w-full">
                <h1 className="title mt-4">{id ? "Edit" : "Create"} Communication Template</h1>
                <Button variant="contained" className="!py-2 !h-[48px] !w-[120px]" onClick={onSave}>
                  Save
                </Button>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="grid grid-cols-2 gap-4 my-4">
              <div>
                <label>Message Type</label>
                <FormControl className="mt-4" fullWidth>
                  {/* <InputLabel id="msgType-label">Message Type</InputLabel> */}
                  <Select
                    value={(formState?.messageType as any) || ""}
                    onChange={(value, e: any) => {
                      setFormState((prev: any) => ({ ...prev, messageType: e.props.value }));
                    }}
                  >
                    <MenuItem value={"TEXT"}>TEXT</MenuItem>
                    <MenuItem value={"HSM"}>HSM</MenuItem>
                    <MenuItem value={"IMAGE"}>IMAGE</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Category Type</label>
                <Select
                  value={(formState?.categoryType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, categoryType: e.props.value }));
                  }}
                >
                  <MenuItem value={"UTILITY"}>UTILITY</MenuItem>
                  <MenuItem value={"MARKETING"}>MARKETING</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label>Communication Type</label>

                <Select
                  value={(formState?.communicationType as any) || ""}
                  onChange={(value, e: any) => {
                    console.log(">>>>>>>value", value, e);
                    setFormState((prev: any) => ({ ...prev, communicationType: e.props.value }));
                  }}
                >
                  <MenuItem value={"COMMUNICATION"}>COMMUNICATION</MenuItem>
                  <MenuItem value={"TRANSACTIONAL"}>TRANSACTIONAL</MenuItem>
                  <MenuItem value={"PROMOTIONAL"}>PROMOTIONAL</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <div id="msgType-label">Template Language</div>
                <Select
                  value={(formState?.templateLang as any) || ""}
                  onChange={(value, e: any) => {
                    console.log(">>>>>>>value", value, e);
                    setFormState((prev: any) => ({ ...prev, templateLang: e.props.value }));
                  }}
                >
                  <MenuItem value={"HINDI"}>HINDI</MenuItem>
                  <MenuItem value={"ENGLISH"}>ENGLISH</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <div id="msgType-label">Provider Type</div>
                <Select
                  value={(formState?.providerType as any) || ""}
                  onChange={(value, e: any) => {
                    console.log(">>>>>>>value", value, e);
                    setFormState((prev: any) => ({ ...prev, providerType: e.props.value }));
                  }}
                >
                  <MenuItem value={"GUPSHUP"}>GUPSHUP</MenuItem>
                </Select>
              </FormControl>
            </div>
            <CkEditorFullOptions
              label="Body"
              value={formState.body}
              onChange={(value: any) => {
                setFormState((prev: any) => ({ ...prev, body: value }));
              }}
              className="!mb-4"
            />

            <div className="grid grid-cols-2 gap-4 my-4">
              {["Name", "Subject", "Utm Params", "Mask"].map((label) => (
                <div className="flex flex-col">
                  <label>{label}</label>
                  <TextField
                    key={label}
                    value={formState[toCamelCase(label) as keyof FormState]}
                    onChange={handleChange(toCamelCase(label) as keyof FormState)}
                  />
                </div>
              ))}
            </div>

            <FormControl fullWidth className="!mb-4">
              <div id="isActive-label">Status</div>
              <Select
                value={formState.isActive}
                onChange={(value, e: any) => {
                  setFormState((prev: any) => ({ ...prev, isActive: e.props.value }));
                }}
              >
                <MenuItem value={"true"}>Yes</MenuItem>
                <MenuItem value={"false"}>No</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
};

export default CrateEditFlowForCommunication;
